<template>
    <MobileModal
        :is-open="isOpen"
        :title="title"
        :portal-target="portalTarget"
        :z-index="9999"
        max-width="400px"
        max-height="none"
        close-icon="outline-clear-24px"
        @close="$emit('close')"
    >
        <template #header>
            <h2 class="m-0 text-base font-medium text-theme-text">{{ title }}</h2>
        </template>

        <!-- Citation formats list -->
        <div class="py-2">
            <template v-for="format in formats">
                <!-- Chicago with expandable submenu -->
                <div v-if="format === 'Chicago'" :key="format">
                    <button
                        type="button"
                        class="flex w-full cursor-pointer items-center justify-between bg-transparent px-4 py-3 text-left hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-theme-accent dark:hover:bg-white/10"
                        @click="$emit('toggle-chicago')"
                    >
                        <div class="flex items-center">
                            <svg-icon icon="quote-24px" class="text-theme-icon" width="20px" height="20px" />
                            <span class="ml-3 text-theme-text">{{ labels[format] }}</span>
                        </div>
                        <svg-icon
                            icon="chevron-down"
                            class="text-theme-icon transition-transform duration-200"
                            width="20px"
                            height="20px"
                            :class="{ 'rotate-180': chicagoExpanded }"
                        />
                    </button>
                    <!-- Chicago subformats -->
                    <transition name="slide-collapse">
                        <div v-show="chicagoExpanded" class="bg-black/[0.02] dark:bg-white/[0.05]">
                            <button
                                v-for="subformat in chicagoSubformats"
                                :key="subformat"
                                type="button"
                                class="flex w-full cursor-pointer items-center bg-transparent py-3 pl-12 pr-4 text-left hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-theme-accent dark:hover:bg-white/10"
                                @click="$emit('select', subformat)"
                            >
                                <span class="text-theme-text">{{ labels[subformat] }}</span>
                            </button>
                        </div>
                    </transition>
                </div>
                <!-- Regular citation formats -->
                <button
                    v-else
                    :key="format"
                    type="button"
                    class="flex w-full cursor-pointer items-center bg-transparent px-4 py-3 text-left hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-theme-accent dark:hover:bg-white/10"
                    @click="$emit('select', format)"
                >
                    <svg-icon icon="quote-24px" class="text-theme-icon" width="20px" height="20px" />
                    <span class="ml-3 text-theme-text">{{ labels[format] }}</span>
                </button>
            </template>
        </div>
    </MobileModal>
</template>

<script>
import MobileModal from './MobileModal.vue';

export default {
    name: 'CitationMobileModal',
    components: {
        MobileModal,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        formats: {
            type: Array,
            required: true,
        },
        chicagoSubformats: {
            type: Array,
            default: () => [],
        },
        chicagoExpanded: {
            type: Boolean,
            default: false,
        },
        labels: {
            type: Object,
            required: true,
        },
        /**
         * CSS selector or HTMLElement for portal target.
         * Defaults to '.Reader' to ensure theme inheritance.
         */
        portalTarget: {
            type: [String, HTMLElement],
            default: '.Reader',
        },
    },
};
</script>

<style>
/* Slide collapse transition for Chicago submenu */
.slide-collapse-enter-active,
.slide-collapse-leave-active {
    transition: all 0.2s ease;
    overflow: hidden;
}

.slide-collapse-enter,
.slide-collapse-leave-to {
    opacity: 0;
    max-height: 0;
}

.slide-collapse-enter-to,
.slide-collapse-leave {
    max-height: 200px;
}
</style>
